import {
    trigger,
    transition,
    state,
    style,
    group,
    query,
    animateChild,
    animate,
    keyframes
} from '@angular/animations';

export const DETAIL_ANIMATIONS = [
    trigger('middleContainerState', [
        state('shrunk', style({
            flexDirection: 'row'
        })),
        state('expanded', style({
            flexDirection: 'column-reverse'
        })),
        transition('expanded => shrunk', group([
            query('@middleSectionState', [
                animateChild()
            ]),
            query('@mapSectionState', [
                animateChild()
            ], { optional: true }),
            animate('500ms')
        ]))
    ]),
    trigger('middleSectionState', [
        state('expanded', style({
            margin: '0'
        })),
        transition('expanded => shrunk', group([
            animate('500ms', keyframes([
                style({
                    width: '100%',
                    order: 0,
                    offset: 0
                }),
                style({
                    width: '70%',
                    offset: 0.4
                }),
                style({
                    paddingTop: '400px',
                    width: '70%',
                    offset: 0.5
                }),
                style({
                    paddingTop: '0',
                    width: '100%',
                    offset: 1
                }),
            ]))
        ]))
    ]),
    trigger('mapSectionState', [
        transition('shrunk => expanded', animate('250ms', keyframes([
            style({
                height: 0,
                width: '55%',
                margin: '0 0 100px auto'
            }),
            style({
                height: '550px',
                width: '100%',
                margin: '0 0 100px auto'
            })
        ]))),
        transition('expanded => shrunk', group([
            query('.map-container', [
                style({
                    padding: '0px'
                })
            ], { optional: true }),
            animate('500ms', keyframes([
                style({
                    height: '550px',
                    width: '100%',
                    margin: '0 0 100px auto',
                    offset: 0
                }),
                style({
                    height: '300px',
                    width: '35%',
                    offset: 0.5
                }),
                style({
                    height: 0,
                    offset: 1
                }),
            ]))
        ]))
    ]),
];
